const initState = {
    complianceStandards: [],
    compliance_id: null,
    compliance: null,
    procedures: [],
    actions: [],
    newlyCreatedComplianceId: null,
    compliance_dashboard_data: null,
    activeComplianceId: null,
};

const complianceReducer = (state = initState, action) => {
    switch (action.type) {
        case "SET_ACTIVE_COMPLIANCE":
            ////console.log("reducer action:",action);
            return {
                ...state,
                activeComplianceId: action.compliance_id,
            };

        case "OPEN_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: action.compliance_id,
            };

        case "RESET_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: null,
            };

        case "PROCEDURES":
            return {
                ...state,
                procedures: action.complianceStandards,
            };

        case "COMPLIANCE_ACTIONS":
            return {
                ...state,
                actions: action.actions,
            };

        case "UPDATE_COMPLIANCE_STANDARD":
            return {
                ...state,
                compliance: action.compliance,
            };

        case "RESET_NEWLYCREATED_COMPLIANCE_ID":
            return {
                ...state,
                newlyCreatedComplianceId: null,
            };

        case "COMPLIANCE_CREATED":
            return {
                ...state,
                complianceStandards: action.complianceStandards,
                newlyCreatedComplianceId: action.newlyCreatedComplianceId,
            };

        case "COMPLIANCE_STANDARDS":
            return {
                ...state,
                complianceStandards: action.complianceStandards,
            };
        

        case "COMPLIANCE_STANDARD_DELETE":
            return {
                ...state,
                complianceStandards: state.complianceStandards.filter(
                    (c) => c.compliance_id !== action.id
                ),
                activeComplianceId: state.activeComplianceId === action.id? null : state.activeComplianceId
            };

        default:
            return state;
    }
};

export default complianceReducer;